// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19bvv47k{padding-left:var(--ds-space-250,20px)}\n._19pkxy5q{margin-top:var(--ds-space-400,2pc)}\n._1e0c1n7u{display:inline-grid}\n._4cvr1h6o{align-items:center}\n._5sagi11n{animation-duration:3s}\n._6a6z1h6o{justify-items:center}\n._ca0qv47k{padding-top:var(--ds-space-250,20px)}\n._j7hq1wwu{animation-name:kgnpaw5}\n._n3tdv47k{padding-bottom:var(--ds-space-250,20px)}\n._u5f3v47k{padding-right:var(--ds-space-250,20px)}\n@keyframes kgnpaw5{0%{opacity:0}to{opacity:1}}", ""]);
// Exports
module.exports = exports;
